export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export const RESEND_CONFIRMATION_REQUEST = 'RESEND_CONFIRMATION_REQUEST';
export const RESEND_CONFIRMATION_SUCCESS = 'RESEND_CONFIRMATION_SUCCESS';
export const RESEND_CONFIRMATION_FAILURE = 'RESEND_CONFIRMATION_FAILURE';
export const SIGNUP_PAGE_UNLOADED = "SIGNUP_PAGE_UNLOADED";